import React,{ useCallback, useEffect, useState } from 'react'
import { useProduct } from '../../../../../pages/hooks/product'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from '../../style.module.scss'
import { useDispatch, useSelector } from 'react-redux'

import ProductBreadcrumbNav from '../../components/product-breadcrumb-nav'
import ProductMainContainer from '../../components/product-main-container'
import ProductReviews from '../../components/product-reviews'
import ProductRecommendation from '../../components/product-recommendation'
import ProductBabiesLooks from '../../components/product-babies-looks'
import ProductBeautyLooks from '../../components/product-beauty-looks'
import ProductRelatedSearches from '../../components/product-related-searches'
import ZoomImagePopover from '../../module/zoom-image-popover'
import Footer from "../../../../layout/fragments/footer/index"
import { action_fetch_customer } from '../../../../../../store/actions/pages/customer'
import BottomBannerTip from '../../../../layout/fragments/bottom-banner'
// import ProductShopTheLook from '../../components/product-shop-the-look/index'
// import { fetchProductShopTheLookNew } from '../../../../../../api'
// import { useParams } from 'react-router-dom'

const NormalPage = props => {
    useStyles(classes)
    const productHooks = useProduct();
    const pageProduct = useSelector((state) => state.pageProduct);
    // const { promotions } = pageProduct
    // const pageParams = useParams()
    // const [shopTheLookNewData, setShopTheLookNewData] = useState(null)
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { customer } = pageCustomer;
    const dispatch = useDispatch();

    const {
        productVO,
        selectedProduct,
        reviewSummary,
        isBeautyMakeup,
        selectedVariant
    } = productHooks

    useEffect(async () =>{
        if(!customer?.id){
            await dispatch(action_fetch_customer());
        }
    }, [customer?.id]);

    const getTotalSummary = useCallback(sm =>{
        let commentSummary = sm?.commentSummary
        let score1 = parseInt((commentSummary?.score1)),score2 = parseInt((commentSummary?.score2)),score3 = parseInt((commentSummary?.score3)),score4 = parseInt((commentSummary?.score4)),score5 = parseInt((commentSummary?.score5));
        let total = score1 + score2 + score3 + score4 + score5;
        let avgScore = (score1 + 2*score2 + 3*score3 + 4*score4 + 5*score5)/total;
        return {...sm, total,avgScore}
    }, [])

    const reviewItem = getTotalSummary(reviewSummary);



    // useEffect(() => {
    //     let params = {
    //         "shopTheLookProductId": pageParams?.id,
    //     }

    //     if (selectedVariant) {
    //         params.mainShoppableProduct = {
    //             "variantId": selectedVariant?.id,
    //             "qty": 1,
    //             "selected": true
    //         }
    //     }
        
    //     getShopTheLookNewData(params)
    // }, [selectedProduct])

    // const getShopTheLookNewData = async (params) => {
    //     const response = await fetchProductShopTheLookNew(params);
    //     if (response && response?.code == 200) {
    //         setShopTheLookNewData(response?.result)
    //     } else {
    //         setShopTheLookNewData(null)
    //         console.log("shop the look 新接口请求报错：", response?.result || response)
    //     }
    // }
    return (<div className={classes.ProductTotalContainer}>

            <div className={classes.ThirteenContainer}>
                <ProductBreadcrumbNav />
                <ProductMainContainer 
                    productHooks={productHooks} 
                    reviewItem={reviewItem}
                />
            </div>
            
            <div className={classes.TwelveContainer}>
                <ProductBabiesLooks babiesLooks={selectedProduct.babiesLooks} selectedProduct={selectedProduct} />
                {
                    isBeautyMakeup && productVO?.beautyLooks?.length > 0 && <ProductBeautyLooks beautyLooks={productVO.beautyLooks} />
                }

                {/* {
                    shopTheLookNewData &&
                    <ProductShopTheLook
                        productHooks={productHooks}
                        productId={selectedProduct?.id}
                        shopTheLookData={shopTheLookNewData}
                        updateShopTheLook={params => getShopTheLookNewData(params)}
                        pageParamsId={pageParams?.id}
                        />
                } */}

                <ProductReviews 
                    productHooks={productHooks}  
                    reviewItem={reviewItem}
                />

                <ProductRecommendation productHooks={productHooks} />

                <ProductRelatedSearches productHooks={productHooks}   />
            </div>
            
            {
                pageProduct?.imagePopover?.image && <ZoomImagePopover imagePopover={pageProduct?.imagePopover} />
            }
        
            <Footer />

            <BottomBannerTip />
        </div>
    )
}

export default NormalPage;